"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinSessionResponseSchema = exports.PinConfirmRequestSchema = exports.VerifyPinRequestSchema = exports.DisablePinRequestSchema = exports.ChangePinRequestSchema = exports.SetPinRequestSchema = exports.PinSchema = exports.SetTimezoneRequestSchema = exports.SetLocaleRequestSchema = void 0;
const zod_1 = require("zod");
const locale_1 = require("../locale");
const timezone_1 = require("../timezone");
const auth_1 = require("./auth");
exports.SetLocaleRequestSchema = zod_1.z.object({
    locale: zod_1.z.enum(locale_1.LOCALES),
});
exports.SetTimezoneRequestSchema = zod_1.z.object({
    /** An IANA zone this runtime knows, or null for "automatic". */
    timezone: zod_1.z.string().refine(timezone_1.isTimezone, { message: 'Unknown time zone' }).nullable(),
});
/** Four to six digits; the string form keeps leading zeros. */
exports.PinSchema = zod_1.z.string().regex(/^\d{4,6}$/, { message: 'PIN must be 4 to 6 digits' });
exports.SetPinRequestSchema = zod_1.z.object({ pin: exports.PinSchema });
exports.ChangePinRequestSchema = zod_1.z.object({ currentPin: exports.PinSchema, pin: exports.PinSchema });
exports.DisablePinRequestSchema = zod_1.z.object({ currentPin: exports.PinSchema });
exports.VerifyPinRequestSchema = exports.SetPinRequestSchema;
exports.PinConfirmRequestSchema = zod_1.z.object({ code: zod_1.z.string().regex(/^\d{6}$/) });
/** Every PIN endpoint that changes the lock state answers with a fresh token and the profile. */
exports.PinSessionResponseSchema = zod_1.z.object({
    accessToken: zod_1.z.string(),
    user: auth_1.UserProfileSchema,
});
//# sourceMappingURL=me.js.map